import React from 'react';
import {PropTypes} from 'prop-types';
import {AssignProperties, ToString, NormalizeClassNameString} from './utils';
import {SimpleTooltip} from './tooltip';
import moment from 'moment-timezone';

export class EmailBlackListStatusComponent extends React.Component {
	constructor(props, ...others) {
        super(props, ...others);
        this.strings = {...this.constructor.defaultProps.strings};
        //Getting only needed strings
        AssignProperties(this.strings, props.strings);
    }

    render() {
        const self = this;
        const {className, statusData: data} = self.props;
        const strings = self.strings;

        if (!Boolean(data) || !Boolean(data.IsBounced) && !Boolean(data.BounceReason)) {
            return null;
        }

        let title = '';
        let iconClass = ToString(className) + ' fa fa-warning';

        if (Boolean(data.IsBounced)) {
            title = strings.M_InBlackList;
            iconClass += ' text-danger';
        }
        else {
            title = strings.M_BlackListCandidate;
            iconClass += ' text-warning';
        }

        iconClass = NormalizeClassNameString(iconClass);
        const lastUpdatedAt = data.LastUpdatedAt;

        const tooltipContent = Boolean(data.BounceReason)
            ?   <div className="text-left">
                    <p className="fs-base"><span className={'mre-2 ' + iconClass} />{title}</p>
                    <div className="text-pre-line fs-sm">
                        <span className="font-weight-semibold">{strings.L_Reason}:</span>
                        <br />
                        {ToString(data.BounceReason)}
                    </div>
                    {Boolean(lastUpdatedAt) && <div className="text-right pt-1"><span className="fs-xs text-decoration-overline">{moment.utc(lastUpdatedAt).format('L LT (UTC)')}</span></div>}
                </div>
            :   <div className="text-left">
                    <div className="fs-base"><span className={'mre-2 ' + iconClass} />{title}</div>
                    {Boolean(lastUpdatedAt) && <div className="text-right pt-1"><span className="fs-xs text-decoration-overline">{moment.utc(lastUpdatedAt).format('L LT (UTC)')}</span></div>}
                </div>;

        return (
            <SimpleTooltip placement="bottom" title={tooltipContent} isHtml maxWidth={425} theme="black">
                <span className={'blacklist-symbol sh-email-blacklist-info ' + iconClass} />
            </SimpleTooltip>
        );
    }
}
EmailBlackListStatusComponent.propTypes = {
    strings: PropTypes.object,
    statusData: PropTypes.shape({
        IsBounced: PropTypes.bool, 
        BounceReason: PropTypes.string, 
        LastUpdatedAt: PropTypes.any
    }),
}
EmailBlackListStatusComponent.defaultProps = {
    strings: {
        M_InBlackList: 'This email address is in the Amazon\'s SES IP Blacklist and no letter will be sent to it.',
        M_BlackListCandidate: 'This email address is about to get to the Amazon\'s SES IP Blacklist.',
        L_Reason: 'Reason'
    },
    statusData: null
}
